export const successStories = [
  {
    id: 1,
    client: "Logística Global S.A. de C.V.",
    industry: "Transporte y Logística",
    challenge: "Optimizar el control de inventarios y reducir errores en el Anexo 24.",
    solution: "Implementación de nuestro sistema de control de inventarios Anexo 24 con integración a su ERP.",
    result: "Reducción del 30% en errores de inventario y agilización del 20% en procesos de auditoría aduanera."
  },
  {
    id: 2,
    client: "Manufacturas del Norte",
    industry: "Automotriz",
    challenge: "Recuperación y organización de expedientes digitales VUCEM atrasados.",
    solution: "Servicio de integración y recuperación de Expediente Digital conforme a VUCEM.",
    result: "Normalización del 100% de los expedientes digitales en 3 meses y mejora en el cumplimiento normativo."
  },
  {
    id: 3,
    client: "Importaciones Express",
    industry: "Comercio Internacional",
    challenge: "Necesidad de asesoría aduanal especializada para nuevas rutas de importación.",
    solution: "Asesoría aduanal continua y gestión de permisos para nuevas categorías de productos.",
    result: "Expansión exitosa a 2 nuevos mercados y reducción del 15% en tiempos de despacho aduanero."
  }
];